export default __webpack_public_path__ + "static/media/16.e8f8dc33.jpeg";